import { Box } from "@mui/material";
import { useAtom } from "jotai";
import {
  contentWidthAtom,
  isLoaderActiveAtom,
  selectedOrgIdAtom,
  setActiveMenuItemFromPathAtom,
} from "../../atoms";
import { Route, User } from "../../types";
import { Topbar } from "../topbar";
import {
  ChangePasswordRoute,
  DashboardErrorRoute,
  openRoutes,
  Router,
} from "../../routes/";
import { Role } from "../../enums";
import {
  CustomerSidebar,
  OrganizationAdminSidebar,
  SuperAdminSidebar,
} from "../sidebar";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Loading from "../common/loading/Loading";

type DashboardLayoutProps = {
  routes: Route[];
  user: User;
};

export const DashboardLayout = ({ routes, user }: DashboardLayoutProps) => {
  const [contentWidth] = useAtom(contentWidthAtom);
  const [, setSelectedOrgId] = useAtom(selectedOrgIdAtom);
  const [isLoaderActive] = useAtom(isLoaderActiveAtom);
  const [, setActiveMenuItemFromPath] = useAtom(setActiveMenuItemFromPathAtom);
  const location = useLocation();

  useEffect(() => {
    if (routes) setActiveMenuItemFromPath(location.pathname, routes);
  }, [location, routes]);

  useEffect(() => {
    if (user && user.roleCode !== Role.SuperAdmin) setSelectedOrgId(user.orgId);
  }, [user]);

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
      }}
    >
      {isLoaderActive && (
        <Loading
          message=" "
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2,
            backgroundColor: "rgba(255, 255, 255, 0.6)",
          }}
        />
      )}
      <Box sx={{ height: "100%" }}>
        {user.roleCode === Role.SuperAdmin ? (
          <SuperAdminSidebar menu={routes} />
        ) : user.roleCode === Role.Admin ? (
          <OrganizationAdminSidebar menu={routes} />
        ) : (
          <CustomerSidebar menu={routes} />
        )}
      </Box>
      <Box sx={{ width: contentWidth }}>
        <Box
          sx={{
            width: "100%",
          }}
        >
          {user && <Topbar userName={`${user.firstName} ${user.lastName}`} />}
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            p: 3,
          }}
        >
          {user.isPasswordReset ? (
            <Router
              routes={[ChangePasswordRoute]}
              redirectRoutes={[...routes, ...openRoutes]}
              redirectTo={ChangePasswordRoute.path}
              errorRoute={DashboardErrorRoute}
            />
          ) : (
            <Router
              routes={routes}
              redirectRoutes={openRoutes}
              redirectTo={routes[0].path}
              errorRoute={DashboardErrorRoute}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};
